import styled, { css } from 'styled-components';
import BaseIcon from '../Icon/Icon';
import {
  IconStyledProps,
  NotificationIntent,
  TextStyledProps,
} from './Notification.typed';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const Icon = styled(BaseIcon)<IconStyledProps>(
  ({ theme, intent }) => css`
    margin-right: ${theme.spacing.S8};
    color: ${theme.brand[intent].base};
  `,
);

// TODO: Update to use the Text component
export const Text = styled.p<TextStyledProps>(
  ({ theme, intent }) => css`
    font-size: ${theme.typography.fontSizes.B12};
    line-height: ${theme.typography.fontSizes.M16};
    color: ${intent === NotificationIntent.ERROR ? '#CC2324' : `#666666`};
  `,
);
